import {  FC } from 'react';
import {
 TableRow
} from '@mui/material';

import { ArticleParMoisAvecCommissionI } from './CommissionForm'
import { StyledTableCell } from '../../content/parametrage/Pays/Pays';
import { AllMounth, idTypeInBDD } from '../../../constants/Constants';
interface RowCommissioonProps {
  article: ArticleParMoisAvecCommissionI;
}


const RowCommission: FC<RowCommissioonProps> = ({
  article
}) => {
  return (
    <TableRow>
      <StyledTableCell component="th" scope="row">
        {article?.client}
      </StyledTableCell>
      <StyledTableCell align="center">{article?.operation}</StyledTableCell>
      <StyledTableCell align="center">{article?.articles}</StyledTableCell>
      <StyledTableCell align="center"> {AllMounth.find((x) => x.id === article?.Mois)?.mounth} {article?.Annee}</StyledTableCell>
      <StyledTableCell align="center">{
      article?.type}</StyledTableCell>
      <StyledTableCell  align="center">
        {article?.ca && Number(article?.ca).toFixed(2)} -{" "}
        {article?.code_iso ?? "Pas De Devise Facturation"}
      </StyledTableCell>
      <StyledTableCell  align="center">
        {article?.taux_commission} {" "} %
      </StyledTableCell>
      <StyledTableCell align="center">  
        {article?.typeId == idTypeInBDD ? 0 : article?.Commission && Number(article?.Commission).toFixed(2)} -{" "}
        {article?.Commission_Devise ?? "Pas De Devise Commission"}
      </StyledTableCell>
  </TableRow>
  )
}

export default RowCommission
